var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8824 7.58824C11.8824 7.13346 12.2511 6.76471 12.7059 6.76471C13.1607 6.76471 13.5294 7.13346 13.5294 7.58824V8.82353V12.3007V14.0533L11.9369 14.9728L11.8824 15V13.3529V10.8524C11.3977 11.1328 10.8356 11.2941 10.2353 11.2941C8.4185 11.2941 6.94541 9.82332 6.94141 8.00743H6.94118C6.94118 7.09778 6.20378 6.36038 5.29412 6.36038C4.38446 6.36038 3.64706 7.09778 3.64706 8.00743V8.41177C3.64706 8.86654 3.27842 9.23529 2.82353 9.23529C2.36876 9.23529 2 8.86654 2 8.41177V7.17647V4.29412V1.94672L3.5925 1.02722L3.64706 1V2.64706V5.15505C4.13168 4.87459 4.69386 4.71332 5.29412 4.71332C7.11092 4.71332 8.584 6.18412 8.58801 8H8.58824C8.58824 8.90966 9.32564 9.64706 10.2353 9.64706C11.145 9.64706 11.8824 8.90966 11.8824 8V7.58824ZM13.5294 5.11479C13.5294 4.66208 13.1622 4.29504 12.7095 4.29504C12.2567 4.29504 11.8896 4.66208 11.8896 5.11479C11.8896 5.56762 12.2567 5.93466 12.7095 5.93466C13.1622 5.93466 13.5294 5.56762 13.5294 5.11479ZM2.81987 10.0591C3.2727 10.0591 3.63974 10.4261 3.63974 10.879C3.63974 11.3317 3.2727 11.6987 2.81987 11.6987C2.36704 11.6987 2 11.3317 2 10.879C2 10.4261 2.36704 10.0591 2.81987 10.0591Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBrand);
export default __webpack_public_path__ + "static/media/hi-brand.671d07234374d346531ca0a06cca686a.svg";
export { ForwardRef as ReactComponent };